export const isBoqUncovered = (boq) => {
  if (!boq) return false;
  const v = boq.total_cost;
  if (v == null || v === "") return true;
  const n = Number(v);
  return Number.isNaN(n) || n === 0;
};
